import Image from 'next/image';
import Link from 'next/link';

import { cn } from '@kit/ui/utils';

function LogoImage({ className }: { className?: string }) {
  return (
    <>
      <Image
        src="/images/logo.svg"
        alt="Logo"
        width={115}
        height={32}
        className={cn(`h-auto w-[100px] lg:w-[115px] dark:hidden`, className)}
      />
      <Image
        src="/images/logo-white.svg"
        alt="Logo"
        width={115}
        height={32}
        className={cn(
          `hidden h-auto w-[100px] lg:w-[115px] dark:block`,
          className,
        )}
      />
    </>
  );
}

export function AppLogo({
  href,
  label,
  className,
  withoutLink = false,
}: {
  href?: string | null;
  className?: string;
  label?: string;
  withoutLink?: boolean;
}) {
  if (href === null) {
    return <LogoImage className={className} />;
  }

  if (withoutLink) {
    return <LogoImage className={className} />;
  }

  return (
    <Link aria-label={label ?? 'Home Page'} href={href ?? '/'} prefetch={true}>
      <LogoImage className={className} />
    </Link>
  );
}
